import { SystemOsType } from '@enums/system-os-type.enum';
import { serializable, alias, deserialize } from 'serializr';
import { Base } from './base.model';
import { Deserializable } from './deserializable';
import { SystemType } from '@enums/system-type.enum';

export class System extends Base implements Deserializable {
  @serializable(alias('record_active'))
  public enabled: boolean;
  @serializable
  public hostName: string;
  @serializable
  public ipAddress: string;
  @serializable
  public port: number;
  @serializable
  public httpsPort: number;
  @serializable
  public osType: SystemOsType;
  @serializable
  public title: string;
  @serializable(alias('is_public'))
  public isPublic;
  @serializable
  public osVersion: string;
  @serializable
  public protocol: string;
  @serializable
  public systemType: SystemType;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(System, input));
  }

  get isMac() {
    return this.osType === SystemOsType.MACOSX;
  }

  get isLinux() {
    return this.osType === SystemOsType.LINUX;
  }

  get isWindows() {
    return this.osType === SystemOsType.WINDOWS;
  }

  get osName() {
    switch (this.osType) {
      case SystemOsType.WINDOWS:
        return 'Windows';
      case SystemOsType.MACOSX:
        return 'macOS';
      case SystemOsType.LINUX:
        return 'Linux';
    }
  }
}
